import { Navigate, Route, Routes } from 'react-router-dom'
import BoxTruckPricingAnalyticsPage from './BoxTruckPricingAnalyticsPage'

export default function BoxTruckPricingAnalyticsRoutes() {
    return (
        <Routes>
            <Route index element={<BoxTruckPricingAnalyticsPage />} />
            <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
    )
}
